import { KazooRequest } from "@kazoohr/types";

import { omitObjectKeys } from "./omitObjectKeys";

/**
 * Returns information about a KazooRequest object, omitting sensitive information
 */
export function sanitizeKazooRequest(request?: KazooRequest) {
  if (request) {
    return {
      headers: omitObjectKeys({
        object: request.headers || {},
        keysToOmit: SENSITIVE_REQUEST_HEADERS,
      }),
      method: request.method,
      url: request.url,
      host: request.hostname,
    };
  }
}

export const SENSITIVE_REQUEST_HEADERS: (keyof KazooRequest["headers"])[] = [
  "authorization",
  "cookies",
  "cookie",
];
